/**
 * Cihaz Ayarlar sekmesi — kayıt sonucu uyarısı (#258).
 *
 * Sekmelere verilen `setAlerts`, sayfanın / drawer'ın uyarı listesidir ve
 * öğeleri `{ id, message, severity }` biçiminde okur (DetailShell,
 * DeviceSettingsDrawer). Sekmeler eskiden `[{ type, text }]` ile listeyi
 * değiştiriyordu: mesaj yerine "Bir hata oluştu", severity'siz (yeşil) ve
 * kapanmayan bir kutu çıkıyordu. Buradan eklenir ve süre dolunca kalkar.
 */
export function pushTimedAlert(setAlerts, message, severity = "success", autoRemoveMs = 5000) {
  if (typeof setAlerts !== "function") return;
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  setAlerts((prev) => [...(prev || []), { id, message, severity }]);
  setTimeout(() => {
    setAlerts((prev) => (prev || []).filter((a) => a.id !== id));
  }, autoRemoveMs);
}

/**
 * Yazma yanıtından kullanıcı uyarısı. Sunucu (v2 ve OKC) makinenin onayından
 * sonra `{ results, summary: { accepted, rejected } }` döner; stage'de özet
 * yok, yalnız `message`.
 * @returns {{ message: string, severity: "success"|"warning"|"error" }}
 */
export function settingsSaveAlert(payload) {
  const summary = payload?.summary;
  if (summary) {
    const accepted = Number(summary.accepted) || 0;
    const rejected = Number(summary.rejected) || 0;
    if (rejected > 0 && accepted === 0) {
      return { message: `Ayarlar makinede uygulanamadı (${rejected} ayar).`, severity: "error" };
    }
    if (rejected > 0) {
      return {
        message: `${accepted} ayar kaydedildi, ${rejected} ayar makinede uygulanamadı.`,
        severity: "warning",
      };
    }
  }
  return {
    message: typeof payload?.message === "string" && !summary ? payload.message : "Ayarlar başarıyla kaydedildi.",
    severity: "success",
  };
}
